var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPencilIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3091_990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.48363 0.290822C8.87139 -0.0969408 9.50007 -0.0969403 9.88784 0.290822L11.7092 2.11216C12.0969 2.49992 12.0969 3.12861 11.7092 3.51637L3.92992 11.2956L1.23465 11.9694C0.507449 12.1513 -0.15125 11.4925 0.03055 10.7653L0.704367 8.07008L8.48363 0.290822ZM9.18573 1.27377L1.78026 8.67924L1.26676 10.7332L3.32076 10.2197L10.7262 2.81427L9.18573 1.27377Z",
    fill: "#546B8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88493 4.89649L7.19988 3.21144L8.0424 2.36891L9.72746 4.05397L8.88493 4.89649Z",
    fill: "#546B8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3091_990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencilIcon);
export default __webpack_public_path__ + "static/media/edit-pencil-icon.56c75aa4.svg";
export { ForwardRef as ReactComponent };